import React from 'react';
import './Section5.css';

const Section5 = () => {

  return (
    <section className="section5 contact-section" id="contact">

      <div className="contact-bg-shape-left" />
      <div className="contact-bg-shape-right" />
      <div className="contact-content">
        <div className="contact-bg-panel" />
        <div className="contact-left">
          <h2 className="contact-title">Get in Touch</h2>
          <p className="contact-desc">
            Need more details about our products? We're here to assist you!
          </p>
        </div>
        <div className="contact-right">
          <div className="contact-email">
            <p className="email-label">Email us at:</p>
            <a href="mailto:support@appstoria.co" className="email-address">support@appstoria.co</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section5;
